<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $tc('cinema', 1)}} {{ $t('loyaltysettings') }}</div>
      <div>
        <router-link
          class="btn-blue"
          :to="'edit-cinema-loyalty-settings?cls_id=' + cls_id"
        >{{ $t('edit') }}</router-link>
        <router-link
          class="btn-blue"
          to="cinema-loyalty-settings"
        >{{ $tc('cinema', 1)}} {{ $t('loyaltysettings') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>
    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $tc('cinema', 1)}}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ selectedcinema }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div
            class="col-md-3 col-lg-2 col-xl-5"
          >{{ $t('global')}} {{ $t('loyaltysettings') }} {{ $t("name") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.ls_name }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t("canavailonline") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.redemption_online == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t("availatboxoffice") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.redemption_bo == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t("availatconcession") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.redemption_fnb == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('minimumpointsforredemption') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.minimum_points_redemption }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div
            class="col-md-3 col-lg-2 col-xl-5"
          >{{ $t('maximumpointstoberedeemedpertransaction') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.maximum_points_redemption }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('minimumpointsearnings') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.minimum_points_earning }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('maximumpointsearnings') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.maximum_points_earning }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('requirementtoenroll') }} :</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3"></span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('email') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.email_is_required == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('mobiles') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.mobile_is_required == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('age') }} {{ $t('proof') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.age_proof_is_required == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('proof') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.id_proof_is_required == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('eligibilitytoenroll') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.eligibility_to_enroll }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t("earnpointsondicount") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.earn_points_on_discount == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t("burnpointsondicount") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span v-if="cinema_loyalty_settings.burn_points_on_discount == 'Y'" class="mr-3">{{ $t('yes') }}</span>
            <span v-else class="mr-3">{{ $t('no') }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div
            class="col-md-3 col-lg-2 col-xl-5"
          >{{ $t('Earn') }} {{ $t('boxoffice') }} {{ $t('ratio') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.earn_ratio_bo }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div
            class="col-md-3 col-lg-2 col-xl-5"
          >{{ $t('Earn') }} {{ $tc('fb', 1) }} {{ $t('ratio') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.earn_ratio_fnb }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div
            class="col-md-3 col-lg-2 col-xl-5"
          >{{ $t('Burn') }} {{ $t('boxoffice') }} {{ $t('ratio') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.burn_ratio_bo }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div
            class="col-md-3 col-lg-2 col-xl-5"
          >{{ $t('Burn') }} {{ $tc('fb', 1) }} {{ $t('ratio') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.burn_ratio_fnb }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('createdat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.created_at | dateparse }}</span>
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('createdby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.created_by }}</span>
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1 " class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('updatedat') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.updated_at | dateparse }}</span>
          </div>
        </div>
      </div>
      <div v-if="login_user_role_id === 1 " class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-5">{{ $t('updatedby') }}</div>
          <div class="col-md-9 col-lg-10 col-xl-7">
            <span class="mr-3">{{ cinema_loyalty_settings.updated_by }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import CinemasService from "@/services/CinemasService";
import MarketingService from "@/services/MarketingService";
import MasterService from '@/services/MasterService';

export default {
  data() {
    return {
      selectedcinema: "",
      cls_id: null,
      login_user_role_id: null,
      cinema_loyalty_settings: []
    };
  },
  beforeMount() {
    const { cls_id } = this.$route.query;
    this.cls_id = cls_id;
    this.getCinemaList();
    this.getCinemaLoyaltySettingsBYID(cls_id);
    const { role_id } = this.secureStore.get("USINFO");
    this.login_user_role_id = role_id;
  },
  methods: {
    getCinemaList: function(cine_id) {
      CinemasService.GetActiveCinemas({ activekey: "cine_is_active" })

        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            if (cine_id === undefined) {
            } else {
              this.cinemaList.map(x => {
                if (cine_id == x.cine_id) {
                  this.selectedcinema = x.cine_name;
                }
              });
            }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },

    getCinemaLoyaltySettingsBYID: function(id) {
      let payload = {
        cls_id: id
      };
      MarketingService.GetCinemaLoyaltySettingsBYID(payload)
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinema_loyalty_settings = data.Records[0];
            this.getViewUsersDetails(
              this.cinema_loyalty_settings.created_by,
              "created_by"
            );
            this.getViewUsersDetails(
              this.cinema_loyalty_settings.updated_by,
              "updated_by"
            );
            this.getCinemaList(this.cinema_loyalty_settings.cinema_id);
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(this._CatchError);
    },
    getViewUsersDetails(user_id, key) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then(response => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this.cinema_loyalty_settings[key] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Pages/MarketingContainer/LoyaltySettingsComponents/viewcinemaloyaltysettings.vue